export interface IEventEventProvider {
  tag: string;
  params?: IEventEventProviderParams;
}

export interface IEventEventProviderParams {
  [x: string]: unknown | null | string | number;
}

export interface IUser {
  id?: number;
  email: string;
  name?: string;
  lastname?: string;
  title?: string;
  type?: string;
  locale?: string;
  avatar?: string;
  fullname?: string;
  organization_name?: string;
  permission?: unknown;
}

export interface IProviders {
  [x: string]: unknown;
}

export enum IEventProviders {
  KINEDU = 'KINEDU',
  MIXPANEL = 'MIXPANEL',
  FB_PIXEL = 'FB_PIXEL',
}

export enum EventType {
  ACTION = 'action',
  VIEW = 'view',
  STATE = 'state',
}

export enum EventProvidersColors {
  KINEDU = '#278ECD',
  MIXPANEL = '#004fe2',
  FB_PIXEL = '#3b5998',
}

export interface IEventSaveLogger extends IEventEventProvider {
  id: string;
  providers: IEventProviders[];
}

export interface IEventSaveLoggerlistProviders {
  color: EventProvidersColors | string;
  name: IEventProviders | string;
}
export interface IEventSaveLoggerlist extends Omit<IEventSaveLogger, 'providers'> {
  id: string;
  providers: IEventSaveLoggerlistProviders[];
  date: Date | string;
}

export default IEventProviders;
